import { ActivityIndicator } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'

import tw from '@/tailwind/tailwind'

export const MenuItemLoading = () => {
    return (
        <SafeAreaView style={tw`flex-1 justify-center items-center`}>
            <ActivityIndicator />
        </SafeAreaView>
    )
}
